import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    type: "",
    isVisible: false,
    userName: "",
    message: "",
    onConfirm: null,
};

export const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        showNotification: (state, action) => {
            state.isVisible = true;
            state.type = action.payload.type;
            state.userName = action.payload.userName;
            state.message = action.payload.message;
            state.onConfirm = action.payload.onConfirm;
        },
        hideNotification: (state) => {
            state.isVisible = false;
            state.userName = "";
            state.message = "";
            state.onConfirm = null;
            state.type = "";
        },
    },
});

export const { showNotification, hideNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
